if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (elt) {
        var len = this.length >>> 0;
        var from = Number(arguments[1]) || 0;
        from = (from < 0)
             ? Math.ceil(from)
             : Math.floor(from);
        if (from < 0)
            from += len;
        for (; from < len; from++) {
            if (from in this &&
                this[from] === elt)
                return from;
        }
        return -1;
    };
}
String.prototype.allTrim = String.prototype.allTrim ||
         function () {
             return this.replace(/\s+/g, ' ')
                       .replace(/^\s+|\s+$/, '');
         };

String.prototype.replaceSpecialChars = String.prototype.replaceSpecialChars ||
         function () {
             return this.replace(',', ' ')
                       .replace(';', ' ')
                       .replace('(', ' ')
                       .replace(')', ' ')
             ;
         };

String.prototype.removeSpecialChars = String.prototype.removeSpecialChars ||
         function () {
             return this.replace(/[&\/\\#,+()$~%'":*?<>{}^_!\[\]=@|]/g, '');
         };
function ValidateCreditCartName(paramName) {
    var returnValue = true;
    var DnbMinLength = 2;

    if (paramName == undefined || paramName == '') {
        return false;

    }

    // Girilen içeriğin başındaki veya sonundaki karakterler harf değilse
    if (!isChar(paramName.substring(0, 1)) || !isChar(paramName.substring(paramName.length - 1, paramName.length))) {
        returnValue = false;
    }
    else {

        // Birden fazla kelime varsa her kelime ayrı ayrı kontrol edilir
        var mySplitResult = paramName.split(" ");
        for (i = 0; i < mySplitResult.length; i++) {
            var value = mySplitResult[i];
            if (value != "") {
                if (!isChar(value) || !checkSpecialCharacter(value) || !checkMinLength(value, DnbMinLength) || !checkBesideVowelOrConsonantCharacterInText(value, 4, true) || !checkBesideVowelOrConsonantCharacterInText(value, 5, false)) {
                    returnValue = false;
                    break;
                }

            }
        }

    }

    return returnValue

}

function isChar(Data) {
    varChars = "abcçdefgğhıijklmnoöpqrsştuüvwxyzABCÇDEFGĞHIİJKLMNOÖPQRSŞTUÜVWXYZ";
    var isChar = true;
    var index = 0;
    while ((index < Data.length) && (isChar)) {
        isChar = (varChars.indexOf(Data.charAt(index)) != -1);
        index++;
    }
    if (!isChar) {
        return false;
    }
    return true;
}
function IsNumeric(Data) {
    varChars = "0123456789";
    var isNum = true;
    var index = 0;
    while ((index < Data.length) && (isNum)) {
        isNum = (varChars.indexOf(Data.charAt(index)) != -1);
        index++;
    }
    if (!isNum) {
        return false;
    }
    return true;
}
function IsNumeric1(Data) {
    varChars = "0123456789";
    var isNum = true;
    var index = 0;
    while ((index < Data.length) && (isNum)) {
        isNum = (varChars.indexOf(Data.charAt(index)) != -1);
        index++;
    }
    if (!isNum) {
        return false;
    }
    return true;
}

function countWords(text) {
    s = text;
    s = s.replace(/(^\s*)|(\s*$)/gi, "");
    s = s.replace(/[ ]{2,}/gi, " ");
    s = s.replace(/\n /, "\n");
    return s.split(' ').length;
}

function checkSpecialCharacter(text) {
    if (text.substring(0, 1) == "ğ" || text.substring(0, 1) == "Ğ") {
        return false;
    }
    else {
        return true;
    }
}

function checkMinLength(txt, minCount) {
    return txt.length >= minCount;
}

function checkBesideVowelOrConsonantCharacterInText(txt, besideCount, isVowel) {
    var count = 0;
    var rtn = true;
    var Chars = new Array();

    if (isVowel) {
        Chars = new Array("a", "e", "o", "ö", "u", "ü", "i", "ı", "A", "E", "O", "Ö", "U", "Ü", "İ", "I");
    }
    else {
        Chars = new Array("q", "w", "r", "t", "y", "p", "ğ", "s", "d", "f", "g", "h", "j", "k", "l", "ş", "z", "x", "c", "v", "b", "n", "m", "ç", "Q", "W", "R", "T", "Y", "P", "Ğ", "S", "D", "F", "G", "H", "J", "K", "L", "Ş", "Z", "X", "C", "V", "B", "N", "M", "Ç");
    }

    for (m = 0; m < txt.length; m++) {
        var isHasChar = false;
        for (n = 0; n < Chars.length; n++) {
            if (Chars[n] == txt.substring(m, m + 1)) { isHasChar = true; }
        }

        if (isHasChar) { count++; } else { count = 0; }

        if (count >= besideCount) {
            rtn = false;
            break;
        }
    }
    return rtn;
}
function controlAddressText(source) {
    var words = ['.mh', 'mah.', 'mahalle', 'cd', 'cad.', 'cadde', '.sk', 'sok.', 'sokak', 'no.', 'no:', 'no'];
    var exists = "0";
    source = source.toLowerCase();
    source = source.split(" ");
    for (i = 0; i < source.lenght; i++) {
        if (words.indexOf(source[i]) != "-1") {
            exists = "1";
        }
        if (i == (source.lenght - 1)) {
            return exists;
        }
    }
}

function ValidateName(source) {
    if (source == undefined || source == '') {
        return false;
    } else {
        if (!checkSpecialCharacter(source) || !checkMinLength(source, 3) || !checkBesideVowelOrConsonantCharacterInText(source, 4, true) || !checkBesideVowelOrConsonantCharacterInText(source, 5, false)) {

            return false;
        }
    }
    var regex = /^[a-zA-ZğüşöçıİĞÜŞÖÇ ]+$/;
    var isValidName = regex.test(source);
    return (isValidName) ? true : false;
}
function ValidateSurname(source) {
    if (source == undefined || source == '') {
        return false;
    } else {
        if (!checkSpecialCharacter(source) || !checkMinLength(source, 3) || !checkBesideVowelOrConsonantCharacterInText(source, 4, true) || !checkBesideVowelOrConsonantCharacterInText(source, 5, false)) {
            return false;
        }
    }
    var regex = /^[a-zA-ZğüşöçıİĞÜŞÖÇ ]+$/;
    var isValidSurname = regex.test(source);
    return (isValidSurname) ? true : false;
}
function ValidatePhone(source) {
    var blockNumber = ['0000000', '1111111', '2222222', '3333333', '4444444', '5555555', '6666666', '7777777', '8888888', '9999999', '1234567', '2345678', '3456789'];
    if (source == undefined || source == '') {
        return false;
    } else {
        if (!checkMinLength(source, 7) || blockNumber.indexOf(source) != -1) {
            return false;
        }
    }
    var regex = /^[0-9]+$/;
    var isValidPhone = regex.test(source);
    return (isValidPhone) ? true : false;
}
function ValidateMoney(source) {
    var regexControlStr = /(?:^\d{1,3}(?:\.?\d{3})*(?:,\d{2})?$)|(?:^\d{1,3}(?:,?\d{3})*(?:\.\d{2})?$)/;
    var isValidMoney = regexControlStr.test(source);
    return (isValidMoney) ? true : false;
}
function ValidateMail(source) {
    var regexControlStr = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var isValidMail = regexControlStr.test(source);
    return (isValidMail) ? true : false;
}
function ValidateDate(source) {
    var regexControlStr = /^\d{2}[./-]\d{2}[./-]\d{4}$/;
    var isValidDate = regexControlStr.test(source);
    return (isValidDate) ? true : false;
}
function ValidateIdentityNumber(ID) {
    if (ID.substr(0, 1) == 0 && ID.lenght != 11) {
        return false;
    }
    var i = 9, md = '', mc = '', digit, mr = '';
    while (digit = ID.charAt(--i)) {
        i % 2 == 0 ? md += digit : mc += digit;
    }
    if (((eval(md.split('').join('+')) * 7) - eval(mc.split('').join('+'))) % 10 != parseInt(ID.substr(9, 1), 10)) {
        return false;
    }
    for (c = 0; c <= 9; c++) {
        mr += ID.charAt(c);
    }
    if (eval(mr.split('').join('+')) % 10 != parseInt(ID.substr(10, 1), 10)) {
        return false;
    }
    return true;
}
function ValidateAddress(source) {
    if (source == undefined || source == '') {
        return false;
    } else {
        var exists = controlAddressText(source);
        var addressFirstChar = source.substring(0, 1);
        var isNumber = IsNumeric(addressFirstChar);
        var ischar = isChar(addressFirstChar);

        if (isNumber || !checkSpecialCharacter(source)) {
            return false;
        }
        source = source.removeSpecialChars().replaceSpecialChars().allTrim();
        var numberOfWors = countWords(source);

        if (numberOfWors < 2) {
            return false;
        }
        if (!checkMinLength(source, 20)) {
            return false;
        }
        //if (exists == "1") {
        //    return false;
        //}

    }
    return true;
}

function ValidatePassword(source) {
    var isnum, isUpper, isLower = false;
    var i = 0;
    var character = '';
    while (i <= source.length) {
        character = source.charAt(i);
        if (!isNaN(character * 1)) {
            isnum = true;
        } else {
            if (character == character.toUpperCase()) {
                isUpper = true;
            }
            if (character == character.toLowerCase()) {
                isLower = true;
            }
        }
        if (i == source.length) {
            if (!isnum || !isUpper || !isLower) {
                return false;
            } else {
                return true;
            }
        }
        i++;
    }
}

function ValidateUserCode(source) {
    //var regexControlStr = /^[a-zA-Z0-9.,/ $@()]+$/;
    var regexControlStr = /^[a-zA-Z0-9ĞğÜüIŞşİıÖöÇç ]+$/;
    var isValidUserCode = regexControlStr.test(source);
    return (isValidUserCode) ? true : false;
}